import { render, staticRenderFns } from "./LinkAction.vue?vue&type=template&id=48ffbb34&scoped=true&"
import script from "./LinkAction.vue?vue&type=script&lang=js&"
export * from "./LinkAction.vue?vue&type=script&lang=js&"
import style0 from "./LinkAction.vue?vue&type=style&index=0&id=48ffbb34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffbb34",
  null
  
)

export default component.exports